<template>
	<div
			id="services-page"
			class="home"
			:class="theme">
		<nav-bar></nav-bar>
		<!--
		<gmap-map
				:center="center"
				:zoom="6"
				class="map-container"
				:options="{styles: mapStyles}"
		>
			<gmap-marker
					:key="index"
					v-for="(m, index) in markers"
					:position="m.position"
					:clickable="true"
					:draggable="true"
					@click="center=m.position"
			></gmap-marker>
		</gmap-map>
		-->
		<div id="quote-form" class="page">
			<h1 class="page__title">{{ $t('Contact') }}</h1>
			<hr class="page__hr">

			<div class="page__container main">

				<div class="page__content left">
					<span><icon name="home" scale="1"></icon> Còrsega, 168, 1º 1ª, 08036 - Barcelona</span>
					<span><icon name="phone" scale="1"></icon> (+34) 93 410 05 32</span>
					<span><icon name="envelope" scale="1"></icon> info@barnatasa.com</span>


				</div>

				<div class="page__content right">

					<strong>{{ $t('Office_hours') }}:</strong>
					<ul>
						<li>
							{{ $t('Mon.') }} {{ $t('to') }} {{ $t('Thu.') }}: <strong>{{ $t('from') }} 09:00h {{ $t('to') }} 13:00h</strong> {{ $t('and') }} {{ $t('from') }} <strong>16:00h {{ $t('to') }} 19:00h</strong>
						</li>
						<li>
							{{ $t('Fri.') }}: <strong>{{ $t('from') }} 09:00h {{ $t('to') }} 14:00h</strong>
						</li>
						<li>
							{{ $t('Sat.') }} {{ $t('and') }} {{ $t('Sun.') }}: <strong>{{ $t('closed') }}</strong>
						</li>
					</ul>


				</div>

			</div>


		</div>
		<div style="margin-bottom: 20vh"></div>
		<logo-bar></logo-bar>
		<footer-bar></footer-bar>
	</div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Vue from 'vue'
    import { localStorageMixin } from '../mixins'
    import Message from '../components/Message.vue'
    import FooterBar from '../components/FooterBar.vue'
    import NavBar from '../components/NavBar.vue'
    import LogoBar from '../components/LogoBar.vue'

	/*
    import * as VueGoogleMaps from 'vue2-google-maps'

    Vue.use(VueGoogleMaps, {
        load: {
            key: 'AIzaSyB__K_9Sk2AOlY8rJKWPy7XYuWRASaWxDU',
            v: '3.28',
            libraries: 'places'
        }
    })
    */

    export default {
        name: 'contact',

        mixins: [localStorageMixin],

        components: {
            Message,
            FooterBar,
            LogoBar,
            NavBar
        },

        data: () => ({

            error: null,
            center: {lat: 41.3891238, lng: 2.1497487},
            markers: [{
                position: {lat: 41.3891238, lng: 2.1497487}
            }],
            mapStyles: [
                {
                    elementType: 'labels',
                    stylers: [{
                        visibility: 'off'
                    }]
                },
                {elementType: 'geometry', stylers: [{color: '#242f3e'}]},
                {elementType: 'labels.text.stroke', stylers: [{color: '#242f3e'}]},
                {elementType: 'labels.text.fill', stylers: [{color: '#746855'}]},
                {
                    featureType: 'administrative.locality',
                    elementType: 'labels.text.fill',
                    stylers: [{color: '#d59563'}]
                },
                {
                    featureType: 'poi',
                    elementType: 'labels.text.fill',
                    stylers: [{color: '#d59563'}]
                },
                {
                    featureType: 'poi.park',
                    elementType: 'geometry',
                    stylers: [{color: '#263c3f'}]
                },
                {
                    featureType: 'poi.park',
                    elementType: 'labels.text.fill',
                    stylers: [{color: '#6b9a76'}]
                },
                {
                    featureType: 'road',
                    elementType: 'geometry',
                    stylers: [{color: '#38414e'}]
                },
                {
                    featureType: 'road',
                    elementType: 'geometry.stroke',
                    stylers: [{color: '#212a37'}]
                },
                {
                    featureType: 'road',
                    elementType: 'labels.text.fill',
                    stylers: [{color: '#9ca5b3'}]
                },
                {
                    featureType: 'road.highway',
                    elementType: 'geometry',
                    stylers: [{color: '#746855'}]
                },
                {
                    featureType: 'road.highway',
                    elementType: 'geometry.stroke',
                    stylers: [{color: '#1f2835'}]
                },
                {
                    featureType: 'road.highway',
                    elementType: 'labels.text.fill',
                    stylers: [{color: '#f3d19c'}]
                },
                {
                    featureType: 'transit',
                    elementType: 'geometry',
                    stylers: [{color: '#2f3948'}]
                },
                {
                    featureType: 'transit.station',
                    elementType: 'labels.text.fill',
                    stylers: [{color: '#d59563'}]
                },
                {
                    featureType: 'water',
                    elementType: 'geometry',
                    stylers: [{color: '#17263c'}]
                },
                {
                    featureType: 'water',
                    elementType: 'labels.text.fill',
                    stylers: [{color: '#515c6d'}]
                },
                {
                    featureType: 'water',
                    elementType: 'labels.text.stroke',
                    stylers: [{color: '#17263c'}]
                }
            ]
        }),

        computed: {
            ...mapGetters(['user',
                'theme'])
        },

        methods: {
            ...mapActions(['LOG_IN_USER'
            ]),
            closeMessage () {
                this.error = null
            }
        },

        head: {
            title: {
                inner: 'Services'
            }
        }

    }

</script>

<style>
	.map-container {
		width: 100%;
		height: 40vh;
	}
</style>


// WEBPACK FOOTER //
// Contact.vue?132a6c08